const { useState } = require("react");

const ROWS_PER_PAGE_OPTIONS = [5, 10, 20];
const ROWS_PER_PAGE_DEFAULT = 20;

const usePagination = (
  total,
  rowsPerPage = ROWS_PER_PAGE_DEFAULT,
  rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS
) => {
  const [limit, setLimit] = useState(rowsPerPage);
  const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(0);

  const onPageChange = (evt, nextPage) => {
    setPage(nextPage);
    setOffset(nextPage * limit);
  };

  const onRowsPerPageChange = (evt) => {
    setLimit(evt.target.value);
  };

  return {
    paginationConfig: {
      limit,
      offset,
      page,
      total,
      rowsPerPageOptions,
      onPageChange,
      onRowsPerPageChange,
    },
    setOffset,
    setPage,
  };
};

export default usePagination;
